import { gql } from 'apollo-boost';

/**new api  */
export const GET_EMAILTEMPLATE_FOLDERS = gql`
  query GetEmailTemplateFolders($propertyId: ID!, $input: getEmailTemplateFoldersInput) {
    getEmailTemplateFolders(propertyId: $propertyId, input: $input) {
      id
      name
      amount
      propertyId
      level
      subfolders {
        id
        name
        amount
        propertyId
        level
        templates {
          id
          landlordTemplateId
          draftLanguage {
            key
            value
          }
          publishedLanguage {
            key
            value
          }
          draftAll {
            key
            value
          }
          folderId
          isEnabled
          name
          landlordId
          referenceNumber
          templateCategory
          relatedBookingCategory
          nominationPlanNames
        }
      }
    }
  }
`;

export const GET_LANDLORD_LEVEL_EMAIL_TEMPLATES = gql`
  query GetLandlordLevelEmailTemplates(
    $landlordId: ID!
    $input: getLandlordLevelEmailTemplateInput
  ) {
    getLandlordLevelEmailTemplate(landlordId: $landlordId, input: $input) {
      id
      name
      landlordId
      topLandlordId
      relatedBookingCategory
      isEnabled
      referenceNumber
      landlordId
      folderId
      templateVersions {
        id
        language
      }
    }
  }
`;

export const GET_LANDLORD_LEVEL_EMAIL_TEMPLATE = gql`
  query GetLandlordLevelEmailTemplate(
    $landlordId: ID!
    $input: getLandlordLevelEmailTemplateInput
  ) {
    getLandlordLevelEmailTemplate(landlordId: $landlordId, input: $input) {
      id
      name
      relatedBookingCategory
      isEnabled
      referenceNumber
      landlordId
      description
      folderId
      theme
      triggerName
      ccTo
      bccTo
      sendTo
      editInfo {
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
      folder {
        id
      }
      applicableProperties {
        id
        name
      }
      templateVersions {
        id
        code
        language
        subject
        preview
        attachments {
          fileUuid
          name
        }
        editInfo {
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
      }
    }
  }
`;

export const GET_EMAILTEMPLATE = gql`
  query GetEmailTemplate($templateId: ID!, $propertyId: ID!) {
    getEmailTemplate(templateId: $templateId, propertyId: $propertyId) {
      id
      name
      templateCategory
      relatedBookingCategory
      templateLevel
      topLandlordId
      landlordId
      propertyId
      slug
      defaultSenderEmail
      defaultSenderName
      variables
      labels
      propertyAccess
      sendTo
      ccTo
      bccTo
      referenceNumber
      folderId
      description
      isEnabled
      theme
      triggerName
      landlordTemplateId
      templateVersion {
        draft {
          id
          code
          language
          status
          subject
          preview
          attachments {
            fileUuid
            name
          }
          editInfo {
            createdAt
            createdBy
            updatedAt
            updatedBy
          }
          publishedAt
          publishedBy
          originId
        }
        published {
          id
          code
          language
          status
          subject
          preview
          attachments {
            fileUuid
            name
          }
          editInfo {
            createdAt
            createdBy
            updatedAt
            updatedBy
          }
          publishedAt
          publishedBy
          originId
        }
      }
      editInfo {
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
      folder {
        id
      }
      lastUsedBy
      lastUsedAt
      usedTimes
    }
  }
`;

export const GET_EMAILTEMPLATE_V2 = gql`
  query GetEmailTemplateV2($templateId: ID!) {
    getEmailTemplateV2(templateId: $templateId) {
      id
      name
      description
      templateCategory
      relatedBookingCategory
      templateLevel
      topLandlordId
      landlordId
      propertyId
      slug
      defaultSenderEmail
      defaultSenderName
      variables
      labels
      propertyAccess
      sendTo
      ccTo
      bccTo
      isEnabled
      templateTriggers {
        id
        templateId
        triggerType
        isAutoTrigger
        triggerAction
        triggerItem
        triggerPoint
        triggerSource
        schedulePoint
        scheduleIntervalDays
        scheduleIntervalOption
        originId
      }
      templateAssignments {
        id
        isEnabled
        editInfo {
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        originId
      }
      editInfo {
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
      referenceNumber
      templateVersion {
        id
        code
        language
        abbreviation
        status
        publishedAt
        publishedBy
        preview
        attachments {
          fileUuid
          name
        }
        subject
        editInfo {
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        originId
      }
    }
  }
`;

export const UPDATE_EMAIL_TEMPLATE_STATUS = gql`
  mutation MutationActiveEmailTemplate(
    $templateAssignment: updateTemplateAssignmentInput!
    $templateId: ID!
  ) {
    activeEmailTemplate(templateAssignment: $templateAssignment, templateId: $templateId) {
      success
    }
  }
`;

export const CREATE_EMAIL_TEMPLATE = gql`
  mutation CreateEmailTemplate($emailTemplate: createEmailTemplateInput!) {
    createEmailTemplate(emailTemplate: $emailTemplate) {
      templateVersionId
    }
  }
`;

export const CREATE_LANDLORD_LEVEL_EMAIL_TEMPLATE = gql`
  mutation CreateLandlordLevelEmailTemplate(
    $landlordId: ID!
    $input: createLandlordLevelEmailTemplateInput!
  ) {
    createLandlordLevelEmailTemplate(landlordId: $landlordId, input: $input) {
      id
    }
  }
`;

export const GET_FOLDERS = gql`
  query GetFolders($input: getFoldersInput!) {
    getFolders(input: $input) {
      folders {
        id
        name
        subfolders {
          id
          level
          name
          propertyId
          landlordId
          topLandlordId
          editInfo {
            createdAt
            createdBy
            updatedAt
            updatedBy
          }
        }
      }
    }
  }
`;

export const DELETE_EMAIL_TEMPLATE = gql`
  mutation DeleteEmailTemplate($templateId: ID!) {
    deleteEmailTemplate(templateId: $templateId) {
      deletedId
    }
  }
`;

export const ARCHIVE_EMAIL_TEMPLATE = gql`
  mutation ArchiveEmailTemplateVersion($templateVersionId: ID!) {
    archiveEmailTemplateVersion(templateVersionId: $templateVersionId) {
      success
    }
  }
`;

export const UPDATE_EMAIL_TEMPALTEVERSINO = gql`
  mutation UpdateEmailTemplateVersion(
    $templateVersionId: ID!
    $templateVersion: updateTemplateVersionInput!
  ) {
    updateEmailTemplateVersion(
      templateVersionId: $templateVersionId
      templateVersion: $templateVersion
    ) {
      id
      templateId
      originId
    }
  }
`;

export const UPDATE_EMAIL_TEMPALTEBASIC = gql`
  mutation UpdateEmailTemplateBasicInfo(
    $emailTemplateId: ID!
    $emailTemplate: updateEmailTemplateBasicInfoInput!
  ) {
    updateEmailTemplateBasicInfo(emailTemplateId: $emailTemplateId, emailTemplate: $emailTemplate) {
      id
    }
  }
`;

export const UPDATE_LANDLORD_LEVEL_EMAIL_TEMPLATE = gql`
  mutation UpdateLandlordLevelEmailTemplate(
    $landlordId: ID!
    $input: updateLandlordLevelEmailTemplateInput!
  ) {
    updateLandlordLevelEmailTemplate(landlordId: $landlordId, input: $input) {
      id
      name
      isEnabled
    }
  }
`;

export const CREATE_EMAIL_TEMPALTEVERSION = gql`
  mutation CreateEmailTemplateVersion(
    $templateId: ID!
    $templateVersion: createTemplateVersionInput!
  ) {
    createEmailTemplateVersion(templateId: $templateId, templateVersion: $templateVersion) {
      id
    }
  }
`;

export const CREATE_LANDLORD_LEVEL_TEMPLATE_VERSION = gql`
  mutation CreateLandlordLevelTemplateVersion(
    $landlordId: ID!
    $input: createLandlordLevelTemplateVersionInput!
  ) {
    createLandlordLevelTemplateVersion(landlordId: $landlordId, input: $input) {
      id
    }
  }
`;

export const UPDATE_LANDLORD_LEVEL_TEMPLATE_VERSION = gql`
  mutation UpdateLandlordLevelTemplateVersion(
    $landlordId: ID!
    $input: updateLandlordLevelTemplateVersionInput!
  ) {
    updateLandlordLevelTemplateVersion(landlordId: $landlordId, input: $input) {
      id
    }
  }
`;

export const GET_LANGUAGES = gql`
  query GetLanguages {
    getLanguages {
      languages {
        language
        abbreviation
        region
        default
      }
    }
  }
`;

export const GET_EMAILTEMPLATEVARIABLES = gql`
  query GetEmailTemplateVariables($key: String) {
    getEmailTemplateVariables(key: $key) {
      templateVariables {
        category
        variables {
          name
          placeholder
          example
          description
        }
      }
    }
  }
`;

export const SendTestEmail = gql`
  mutation SendTestEmail($testSend: testSendInput!, $versionId: ID!) {
    sendTestEmail(testSend: $testSend, versionId: $versionId) {
      success
    }
  }
`;

export const GET_LETTEHEAD = gql`
  query GetLetterhead($propertyId: ID!, $name: String!) {
    getLetterhead(propertyId: $propertyId, name: $name) {
      code
    }
  }
`;

export const GET_USER_ROLE_ACCESS_SCOPES_FULL_ACCESS = gql`
  query GetUserRoleAccessScopesFullAccess($userId: ID!) {
    getUserRoleAccessScopes(userId: $userId) {
      roleId
      fullAccess
      roleName
    }
  }
`;
